export const getStartupParameters = (environment: string): StartupParameters => {
  switch (environment) {
    case 'PROD':
      return prodStartupParameters
    case 'QUAL':
      return ctsStartupParameters
    default:
      return ctnStartupParameters
  }
}

export const defaultStartupParameters: StartupParameters = {
  currency: 'AUD',
  locale: 'en_AU',
  market: 'AU',
  playerId: '',
  ticket: '',
  oddsFormat: 'decimal',
  racingMode: 'false',
  channelId: 3 /* Mobile */,
  offering: 'rwwawa',
}

const ctnStartupParameters: StartupParameters = {
  ...defaultStartupParameters,

  // CTN Parameters
  environment: 'ctn',
  apiBaseUrl: 'https://ctn-api.kambi.com/{api}/{apiVersion}/',
  apiStatisticsBaseUrl: 'https://ctn-api.kambi.com/statistics/api/',
  apiStatisticsGraphqlUrl: 'https://ctn-api.kambi.com/statistics/v2018/graphql/',
  apiLiveOccurrenceBaseUrl: 'https://ctn-api.kambi.com/liveoccurrence/{apiVersion}/',
  apiLiveOccurrencePushUrl: 'wss://ctn-ws.kambi.com/liveoccurrence/{apiVersion}/',
  apiRetailOperatorBaseUrl: 'https://ctn-shop-retail-operator.api.kambi.com/retail-operator-api/',
  apiAuthBaseUrl: 'https://ctn-auth-api.kambicdn.com/{api}/{apiVersion}/',
  pushUrl: 'wss://push-ctn.offering-api.release.kambicdn.com/',
  get apiPlayerBaseUrl() {
    return `https://ctn-auth-api.kambicdn.com/player/api/v2019/${window._kc?.offering || defaultStartupParameters.offering}/`
  },
  get apiOfferingBaseUrl() {
    return `https://ctn-api.kambi.com/offering/v2018/${window._kc?.offering || defaultStartupParameters.offering}/`
  },
  get apiShapeGamesBaseUrl() {
    return `https://configuration-v2.internal.workload.shapegamescloud.com/api/products/sportsbook_web/environments/${this.environment}/applications/${window._kc?.offering || defaultStartupParameters.offering}/`
  },
  apiSupportUrl: 'https://ctn-bo.customer.kambi.com/support/api/',
  get externalWidgetConfigUrl() {
    return `https://ctn-static.kambi.com/client/${window._kc?.offering || defaultStartupParameters.offering}/../widget-disabled.js`
  },
  featureTogglesBaseUrl: 'https://ctn-settings-api.kambicdn.com',
}

const ctsStartupParameters: StartupParameters = {
  ...defaultStartupParameters,

  // CTS Parameters
  environment: 'cts',
  apiBaseUrl: 'https://cts-api.kambi.com/{api}/{apiVersion}/',
  apiStatisticsBaseUrl: 'https://cts-api.kambi.com/statistics/api/',
  apiStatisticsGraphqlUrl: 'https://cts-api.kambi.com/statistics/v2018/graphql/',
  apiLiveOccurrenceBaseUrl: 'https://cts-api.kambi.com/liveoccurrence/{apiVersion}/',
  apiLiveOccurrencePushUrl: 'wss://cts-ws.kambi.com/liveoccurrence/{apiVersion}/',
  apiRetailOperatorBaseUrl: 'https://cts-shop-retail-operator.api.kambi.com/retail-operator-api/',
  apiAuthBaseUrl: 'https://cts-auth-api.kambicdn.com/{api}/{apiVersion}/',
  get apiPlayerBaseUrl() {
    return `https://cts-auth-api.kambicdn.com/player/api/v2019/${window._kc?.offering || defaultStartupParameters.offering}/`
  },
  get apiOfferingBaseUrl() {
    return `https://cts-api.kambi.com/offering/v2018/${window._kc?.offering || defaultStartupParameters.offering}/`
  },
  pushUrl: 'wss://push-cts.offering-api.release.kambicdn.com/',
  get apiShapeGamesBaseUrl() {
    return `https://configuration-v2.internal.workload.shapegamescloud.com/api/products/sportsbook_web/environments/${this.environment}/applications/${window._kc?.offering || defaultStartupParameters.offering}/`
  },
  apiSupportUrl: 'https://cts-bo.customer.kambi.com/support/api/',
  get externalWidgetConfigUrl() {
    return `https://cts-static.kambi.com/client/${window._kc?.offering || defaultStartupParameters.offering}/../widget-disabled.js`
  },
  featureTogglesBaseUrl: 'https://cts-settings-api.kambicdn.com',
}

export const prodStartupParameters: StartupParameters = {
  ...defaultStartupParameters,

  // PROD Parameters
  get apiPlayerBaseUrl() {
    return `https://cf-al-auth-api.kambicdn.com/player/api/v2019/${window._kc?.offering || defaultStartupParameters.offering}/`
  },
  get apiOfferingBaseUrl() {
    return `https://oc-offering-api.kambicdn.com/offering/v2018/${window._kc?.offering || defaultStartupParameters.offering}/`
  },
  pushUrl: 'wss://push-ap.offering-api.kambicdn.com',
  get apiShapeGamesBaseUrl() {
    return `https://configuration-v2.internal.workload.shapegamescloud.com/api/products/sportsbook_web/environments/production/applications/${window._kc?.offering || defaultStartupParameters.offering}/`
  },
}

interface StartupParameters {
  currency: string
  locale: string
  market: string
  playerId: string
  ticket: string
  oddsFormat: string
  racingMode: string
  channelId: number
  offering: string

  // Parameters to overwrite in order to use CTN servers w non-CTN bundle
  environment?: string
  apiBaseUrl?: string
  apiStatisticsBaseUrl?: string
  apiStatisticsGraphqlUrl?: string
  apiLiveOccurrenceBaseUrl?: string
  apiLiveOccurrencePushUrl?: string
  apiRetailOperatorBaseUrl?: string
  apiAuthBaseUrl?: string
  apiPlayerBaseUrl?: string
  apiOfferingBaseUrl?: string
  pushUrl?: string
  apiSupportUrl?: string
  externalWidgetConfigUrl?: string
  featureTogglesBaseUrl?: string
}
